import stringHash from 'string-hash';
import type { RecentSearch, RetrievedRecentSearch } from 'src/common/types/common/RecentSearch';

export type HashableKeys = Omit<RetrievedRecentSearch, 'searchId'> & {
  searchId?: RetrievedRecentSearch['searchId'];
};

const hashedContents = (searchWithoutId: RecentSearch) => {
  const hashableValues = Object.entries(searchWithoutId);
  hashableValues.sort((a, b) => a[0].localeCompare(b[0]));

  const hashable = hashableValues.map(([key, value]) => {
    let sortedValue = value ?? null;
    const firstValueType = typeof sortedValue?.[0];

    // Ensure subvalues are sorted
    if (Array.isArray(sortedValue) && (firstValueType === 'string' || firstValueType === 'number')) {
      sortedValue = sortedValue.flat(Infinity);
      sortedValue.sort();
    }
    return [key, sortedValue].flat(Infinity);
  }).filter(([, value]) => value != null).join(',');
  return `${stringHash(hashable)}`;
};

/**
 * Returns a string hash of Recentsearch contents to use as `searchId` key.
 * - sorts keys to ensure consistent hash
 * - omits searchId key if exists
*/
const recentSearchIdHash = (search: RecentSearch | RetrievedRecentSearch): string => {
  if ('searchId' in search) {
    const { searchId, ...searchWithoutId } = search;
    return hashedContents(searchWithoutId);
  }
  return hashedContents(search);
};

export default recentSearchIdHash;
